import _ from 'lodash';
import { ServicePayPer, ServicePrice } from '../schemas/service-price';

interface IPeopleCount {
  adultCount: number;
  childrenCount?: number;
}
export function getPriceForPeople(
  servicePrice: ServicePrice,
  { adultCount, childrenCount = 0 }: IPeopleCount,
): number {
  if (servicePrice.payPer === ServicePayPer.perHead) {
    return _.round(servicePrice.perAdult * adultCount + servicePrice.perChild * childrenCount, 2);
  }
  if (servicePrice.payPer === ServicePayPer.perSession) {
    return _.round(servicePrice.perSession, 2);
  }
  return 0;
}
